import React, { useEffect, useState } from "react";

const CftcDataTable = ({ currencyPair }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (!currencyPair) {
        setError("Currency pair is required.");
        return;
      }

      setLoading(true);
      setError("");

      try {
        const response = await fetch("https://vidplay-api.deng-software.com/fx/cftcdata", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ currencyPair }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const result = await response.json();
        setData(result.data || []);
      } catch (err) {
        setError("Failed to fetch data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currencyPair]); // Runs whenever currencyPair changes

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">CFTC Data for {currencyPair}</h2>

      {error && <p className="text-red-500">{error}</p>}
      {loading && <p>Loading data...</p>}

      {data.length > 0 && (
  <table className="w-full border-collapse border border-gray-300">
    <thead>
      <tr className="bg-gray-100">
        <th className="border p-2" rowSpan="2">Report Date</th>
        <th className="border p-2" colSpan="5">Long Positions</th>
        <th className="border p-2" colSpan="5">Short Positions</th>
        <th className="border p-2" rowSpan="2">Total Long</th>
        <th className="border p-2" rowSpan="2">Total Short</th>
      </tr>
      <tr className="bg-gray-100">
        <th className="border p-2">Dealer</th>
        <th className="border p-2">Asset Mgr</th>
        <th className="border p-2">Leverage Money</th>
        <th className="border p-2">Other Reportables</th>
        <th className="border p-2">Non-Reportable</th>
        <th className="border p-2">Dealer</th>
        <th className="border p-2">Asset Mgr</th>
        <th className="border p-2">Leverage Money</th>
        <th className="border p-2">Other Reportables</th>
        <th className="border p-2">Non-Reportable</th>
      </tr>
    </thead>
    <tbody>
      {data.map((item, index) => {
        // Convert string values to numbers and calculate totals
        const totalLong =
          (Number(item.dealerPositionsLongAll) || 0) +
          (Number(item.assetMgrPositionsLongAll) || 0) +
          (Number(item.levMoneyPositionsLongAll) || 0) +
          (Number(item.otherReptPositionsLongAll) || 0) +
          (Number(item.nonReptPositionsLongAll) || 0);

        const totalShort =
          (Number(item.dealerPositionsShortAll) || 0) +
          (Number(item.assetMgrPositionsShortAll) || 0) +
          (Number(item.levMoneyPositionsShortAll) || 0) +
          (Number(item.otherReptPositionsShortAll) || 0) +
          (Number(item.nonReptPositionsShortAll) || 0);

        return (
          <tr key={index} className="border-t">
            <td className="border p-2">{item.reportDateAsMMDDYYYY}</td>
            <td className="border p-2">{item.dealerPositionsLongAll}</td>
            <td className="border p-2">{item.assetMgrPositionsLongAll}</td>
            <td className="border p-2">{item.levMoneyPositionsLongAll}</td>
            <td className="border p-2">{item.otherReptPositionsLongAll}</td>
            <td className="border p-2">{item.nonReptPositionsLongAll}</td>
            <td className="border p-2">{item.dealerPositionsShortAll}</td>
            <td className="border p-2">{item.assetMgrPositionsShortAll}</td>
            <td className="border p-2">{item.levMoneyPositionsShortAll}</td>
            <td className="border p-2">{item.otherReptPositionsShortAll}</td>
            <td className="border p-2">{item.nonReptPositionsShortAll}</td>
            <td className="border p-2 font-bold">{totalLong.toLocaleString()}</td>
            <td className="border p-2 font-bold">{totalShort.toLocaleString()}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
)}


    </div>
  );
};

export default CftcDataTable;

